module.exports = __webpack_public_path__ + "static/media/coordinadora_chat.f0f2ecb7.png";